import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { getEmployeeRoleAndUnit } from '../services/api_org_unit';
import { AcademicCapIcon, UserIcon, BuildingOffice2Icon } from '@heroicons/react/24/outline';
import { Link } from 'wouter';


const EmployeeRoleUnits = ({ employeeId, fromPage }) => {
  const { token } = useContext(AuthContext);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showUnits, setShowUnits] = useState(false);

  const fetchUnits = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getEmployeeRoleAndUnit(token, employeeId);
      setUnits(response);
    } catch (err) {
      setError("Errore durante il caricamento delle Unità Organizzative.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = () => {
    if (!showUnits && units.length === 0) {
      fetchUnits();
    }
    setShowUnits(!showUnits);
  };

  return (
    <div>
      <div className={`flex ${fromPage === 'employeeView' ? 'justify-end' : 'justify-start'}`}>
        <button
          onClick={handleToggle}
          className={`${
            fromPage === 'employeeView' ? 'mt-[-28px]' : 'mt-2'
          } inline-flex items-center rounded-sm bg-indigo-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500`}
        >
          {showUnits ? (
              <span>
                  <AcademicCapIcon className='w-5 inline-block me-1' />
                  Nascondi Unità di appartenenza
              </span>
          ) : (
              <span>
                  <AcademicCapIcon className='w-5 inline-block me-1' />
                  Mostra Unità di appartenenza
              </span>
          )}
        </button>
      </div>

      {showUnits && (
        <div className="mt-4">
          {loading && <p className='text-sm text-gray-500'>Caricamento...</p>}
          {error && <p className="text-sm text-gray-600">⚠️ {error}</p>}

          {!loading && !error && units.length === 0 && (
            <p className="text-sm text-gray-500">Nessuna unità organizzativa trovata.</p>
          )}

          {!loading && !error && units.length > 0 && (
            <div className="overflow-x-auto my-4">
              <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-md">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700 w-2/4">Unità organizzativa</th>
                    <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700 w-1/4">Ruolo</th>
                    <th className="px-4 py-2 text-right text-sm font-semibold text-gray-700 w-1/4"></th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {units.map((item, index) => (
                    <tr key={index}>
                      <td className="px-4 py-3 text-sm text-gray-800">
                        {item?.organizational_unit?.name}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <span
                          className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold ${
                            item?.role === 'handler'
                              ? 'bg-indigo-100 text-indigo-800'
                              : 'bg-gray-100 text-gray-700'
                          }`}
                        >
                          {item.role === 'handler' ? (
                            <>
                              <BuildingOffice2Icon className="w-4 me-1.5 inline-block" />
                              Gestore
                            </>
                          ) : (
                            <>
                              <UserIcon className="w-4 me-1.5 inline-block" />
                              Dipendente
                            </>
                          )}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-right">
                        <Link
                          href={`/organization/${item?.organizational_unit?.id}`}
                          className="text-sm font-semibold text-white bg-indigo-600 px-2 py-0.5 hover:bg-indigo-500 inline-flex items-center"
                        >
                          Apri
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EmployeeRoleUnits;
